import React from 'react';
import './NavigationFooter.css';
import { useUserContext } from '../../contexts/UserContext';

export const NavigationFooter: React.FC = () => {

    const userContext = useUserContext();

    return (
        <footer className="PageFooter_footer">
            {userContext.isLoggedIn ? (
                <React.Fragment>
                    <span className='PageFooter_title'>
                        Contact us&nbsp;:&nbsp;<a href="mailto:ca-support@om.asahi-kasei.co.jp">ca-support@om.asahi-kasei.co.jp</a>
                    </span>
                </React.Fragment>
            ) : (
                <span>
                </span>
            )}
        </footer>
    );
}
